 
 
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type IClientMessage } from "./app.interface";
import { appState } from "./state";

export const slice = createSlice({
  initialState: appState,
  name: "app",
  reducers: {
    reset: () => appState,
    toggleLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setServerError: (state, action: PayloadAction<boolean>) => {
      state.serverError = action.payload;
    },
    setClientError: (state, action: PayloadAction<any>) => {
      const { key, data } = action.payload;
      state.clientErrors = { ...state.clientErrors, [key]: data };
    },
    deleteClientError: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const { [key]: _, ...remainingErrors } = state.clientErrors;
      state.clientErrors = remainingErrors;
    },
    addClientMessage(state, action: PayloadAction<IClientMessage>) {
      state.clientMessages[action.payload.key] = action.payload;
    },
    deleteClientMessage: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const { [key]: _, ...remainingMessages } = state.clientMessages;
      state.clientMessages = remainingMessages;
    },
    setForbiddenError: (state, action: PayloadAction<boolean>) => {
      state.forbiddenError = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  reset,
  toggleLoading,
  setServerError,
  setClientError,
  setForbiddenError,
  deleteClientError,
  addClientMessage,
  deleteClientMessage,
} = slice.actions;
